import styled from 'styled-components';

export const ProviderInvitedItemSC = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;

  .img-wrapper {
    width: 120px;
    height: 80px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid ${({ theme }) => theme.color.border.regular};
    border-radius: ${({ theme }) => theme.radius.small}px;
    overflow: hidden;
    background: ${({ theme }) => theme.color.surface.background};

    img {
      width: 100%;
      height: auto;
    }
  }

  .content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-self: stretch;
    justify-content: center;

    border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};
    margin-left: ${({ theme }) => theme.spacings.component.M}px;
  }

  margin-bottom: ${({ theme }) => theme.spacings.component.S}px;
`;
